var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useField } from 'formik';
import { CardSelectionGroup, CardSelectionCard } from '@ally/metronome-ui';
import { useRegisterError } from '../utils';
const getCombinedOnSelection = (field, helpers, onSelection) => {
    function combinedOnSelection(selectedValue) {
        const safeValue = Array.isArray(selectedValue)
            ? JSON.stringify(selectedValue)
            : selectedValue;
        helpers.setValue(safeValue);
        field.onChange(safeValue);
        if (onSelection) {
            onSelection(safeValue);
        }
    }
    return combinedOnSelection;
};
const FormCardSelectionGroup = (_a) => {
    var { name, validate, onSelection, children } = _a, props = __rest(_a, ["name", "validate", "onSelection", "children"]);
    const [field, meta, helpers] = useField({
        name,
        validate,
    });
    const combinedOnSelection = React.useMemo(() => getCombinedOnSelection(field, helpers, onSelection), [field, helpers, onSelection]);
    const { refValue } = useRegisterError(meta.error);
    const error = meta.touched ? meta.error : '';
    return (React.createElement(CardSelectionGroup, Object.assign({ errorNotification: { message: error }, onSelection: combinedOnSelection, ref: refValue }, props), children));
};
export { FormCardSelectionGroup as CardSelectionGroup, CardSelectionCard };
//# sourceMappingURL=CardSelectionGroup.js.map